// Base auction start date
export const AUCTION_START_DATE = new Date(Date.UTC(2025, 2, 25, 0, 0, 0));  // March 25, 2025 00:00 UTC

// Get start date for a specific day
export const getDayStartDate = (dayNumber) => {
    const date = new Date(AUCTION_START_DATE);
    date.setUTCDate(date.getUTCDate() + (dayNumber - 1));
    return date;
};

// Get end date for a specific day
export const getDayEndDate = (dayNumber) => {
    const date = getDayStartDate(dayNumber);
    date.setUTCDate(date.getUTCDate() + 1);
    return date;
};

// Calculate the current auction day based on the start date
export const calculateCurrentDay = () => {
    const now = new Date();
    
    // If auction hasn't started yet, return day 1
    if (now < AUCTION_START_DATE) {
        return 1;
    }
    
    // Calculate days since auction start
    const diffTime = Math.abs(now - AUCTION_START_DATE);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    // Current day is days since start + 1
    return diffDays + 1;
};

// Get current day's target date (either start or end depending on if auction has started)
export const getCurrentTargetDate = () => {
    const now = new Date();
    if (now < AUCTION_START_DATE) {
        return AUCTION_START_DATE; // Count down to auction start
    }
    
    // Calculate current day
    const currentDay = calculateCurrentDay();
    
    return getDayEndDate(currentDay); // Count down to end of current day
};
